export default {
	data() {
		return {
			
		}
	},
	computed: {
		checkinToleranceOptions() {
			if (this.companyIsAmerican) {
				return [
					{text: '300ft', value:91},
					{text: '500ft', value:152},
					{text: '1000ft', value:305},
					{text: '1500ft', value:457},
					{text: '2000ft', value:609},
					{text: '3000ft', value:914},
					{text: '4000ft', value:1219},
					{text: '1mi', value:1610},
					{text: '2mi', value:3220},
					{text: '3mi', value:4828},
					{text: '4mi', value:6737},
					{text: '5mi', value:8046},
					{text: '10mi', value:16093},
					{text: '25mi', value:40234},
					{text: '50mi', value:80467},
					{text: '75mi', value:120701},
					{text: '100mi', value:160934},
					{text: '300mi', value:482803},
					{text: '500mi', value:804672}
				]
			}

			return [
				{text: '100m', value:100},
				{text: '200m', value:200},
				{text: '300m', value:300},
				{text: '400m', value:400},
				{text: '500m', value:500},
				{text: '750m', value:750},
				{text: '1km', value:1000},
				{text: '2km', value:2000},
				{text: '5km', value:5000},
				{text: '10km', value:10000},
				{text: '25km', value:25000},
				{text: '50km', value:50000},
				{text: '75km', value:75000},
				{text: '100km', value:100000},
				{text: '150km', value:150000},
				{text: '200km', value:200000},
				{text: '250km', value:250000},
				{text: '500km', value:500000},
				{text: '1000km', value:1000000}
			]
		},
		hasWonBid() {
			if ("JobBid" in this.$store.project && this.$store.project.JobBid) {
				let activeAcceptedBid = this.$store.project.JobBid.find(bid => {
					return bid.is_active == 1 && bid.status == 'Accepted'
				})

				if (activeAcceptedBid)
					return true
			}
			return false
		},
		estimateLocked() {
			if ("estimate_locked" in this.$store.project)
				return this.$store.project.estimate_locked == 1 ? true : false
			
			return true
		},
		projectHeadingSmall() {
			if (Object.keys(this.$store.project).length > 0) {
				let address = this.$store.project.address

				if (this.$store.project.city)
					address += " "+this.$store.project.city

				return address
			}
			else
				return ""
		},
		requiredRoleListProjects() {
			return this.$store.jobPersonnelRoles.filter(role => role.role_required == 1)
		}
	},
	methods: {
		hasRoleAssigned(role_id) {
			if (this.$store.project && "JobPersonnelRole" in this.$store.project)
				return this.$store.project.JobPersonnelRole.find(role => role.id == role_id)
			else
				return false
		},
		getJobStatus(job) {
			if ('deleted' in job && job.deleted == 1)
				return "Deleted"

			else if ('is_lead' in job && job.is_lead == 1) {
				if ("JobBid" in job && job.JobBid) {
					let activeBid = job.JobBid.find(bid => 'is_active' in bid && bid.is_active == 1)
					if (activeBid && 'status' in activeBid && activeBid.status)
						return "Bid: " + activeBid.status
				}
				return "Bid: Draft"
			}

			else if ('archived' in job && job.archived == 1)
				return "Archived"

			else if ('date_completed' in job && job.date_completed)
				return "Completed " + job.date_completed

			return "Active"
		},
		hasJobPerm(permType,user_id,job_id) {
			let vm = this
			return new Promise((resolve,reject) => {

				if (permType == 'read_perms' && vm.hasModulePermRead('Jobs'))
					resolve(true)
				
				if (permType == 'write_perms' && vm.hasModulePermWrite("Jobs"))
					resolve(true)	

				if (user_id == this.$store.userDetails.id) //we already have this stored on userdetails, so we don't have to query
					resolve(this.hasRoleBasedPermission("project",this.$store.project.id,permType))

				//if we're at this point we need to query for the user's role on the project, and personnel roles
				let jobParams = {
					fields: ["id","User"],
					include: [{model:"User",fields:["id","personnel_role_id"]}]
				}

				let promises = []

				let fetchedJob = false

				//make sure we only fetch roles and job if we don't already have it. This prevents redundant api calls
				let project
				if ("id" in this.$store.project && this.$store.project.id == job_id && "User" in this.$store.project)
					project = this.$store.project
				else {
					fetchedJob = true
					promises.push(this.getJSON("Job/find/"+job_id,jobParams))
				}

				if (this.$store.jobPersonnelRoles.length == 0)
					promises.push(this.fetchJobPersonnelRoles())

				Promise.all(promises).then(responses => {

					if (!project)
						project = responses[0].data

					if (project && "User" in project && project.User) {
						let hasPerm = false
						project.User.forEach(user => {

							if (user.id == user_id) {
								hasPerm = vm.$store.jobPersonnelRoles.find(role => {
									if (user.personnel_role_id == role.id && role[permType] == 1)
										return true
								})

								if (hasPerm)
									hasPerm = true

							}
						})
						resolve(hasPerm)
					}
					else
						resolve(false)
				})
			})
		},
		bindDefaultCollectiveAgreements(unions) {
			let vm = this
			unions.forEach(union => {
				//set default CA if v-model is not bound yet
				if (!vm.$store.projectUnionCollectiveAgreements[union.id]) {
					if ("CollectiveAgreement" in union && union.CollectiveAgreement) {
						let defaultCA = union.CollectiveAgreement.find(ca => ca.is_default == 1)

						if (defaultCA)
							vm.$store.projectUnionCollectiveAgreements[union.id] = defaultCA.id
					}
				}	
			})
		},
		mileageZoneOptions(union_id, ca_id) {
			let union = this.$store.unions.find(u => u.id == union_id)

			let ca = union.CollectiveAgreement.find(c => c.id == ca_id)

			let zones = []

			try {
				zones = JSON.parse(ca.mileage_zones_json)
			}
			catch (e) {}

			return zones.map(zone => {
				return {
					text: zone.label,
					value: zone.label
				}
			})
		},
		fetchProject(spinner,projectSlug) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let slug, fieldIsId = false
			if (projectSlug)
				slug = projectSlug
			else if (this.$route.params.id)
				slug = this.$route.params.id

			return new Promise((resolve,reject) => {

				let params = {
					include_deleted: true,
					include: [
						{
							model: "User",
							fields: ["id","slug","first_name","last_name","personnel_role_id","phone_mobile","user_id"]
						},
						{	
							model: "JobFile", 
							include: [{model: "UploadFile",fields:["id","slug","type","original_filename","filename","thumb_filename"]}],
							fields:["id","slug","is_after","is_file","caption","notes"]
						},
						{
							model: "JobContact",
							include: [{model: "Contact",include:[{model:"Contact",fields:["name"]}]}]
						},
						{
							model: "Service",
							include: ["id"],
							limit: 1 //just to see if there are services
						},
						{
							model: "ScheduleEvent",
							limit: 1
						},
						{
							model: "JobChangeOrder",
							fields: ["id","slug","quote_status","quote_num"],
							filters: [
								["quote_status",["Complete, Pending Approval"]]
							]
						},
						"PayBoost",
						"Category",
						"RevenueCode",
						"Contact", //for customer
						"JobPersonnelRole",
						"JobNote",
						"LocateTicket",
						"JobBid"
					]
				}
				
				this.getJSON("job/find/"+slug,params).then(response =>{

					if (spinner)
						vm.spinner(false)

					if (response.success) {
						vm.$set(vm.$store,"project", response.data)
						vm.$store.project.payboost_ids = vm.primitize(response.data.PayBoost,"payboost_id")


						if (response.data.collective_agreements_json) {
							try {
								vm.$store.projectUnionCollectiveAgreements = JSON.parse(response.data.collective_agreements_json)
							}
							catch (e) {}

							try {
								vm.$store.projectMileageZones = JSON.parse(response.data.mileage_zones_json)
							}
							catch (e) {}
						}
						else {
							//json is null, so we'll build our own with the list of unions
							let collective_agreements_obj = {}
							let mileage_zones_obj = {}
							if (vm.$store.unions) {
								vm.$store.unions.forEach(union => {
									collective_agreements_obj[union.id] = 0
									mileage_zones_obj[union.id] = 0
								})
							}

							vm.$store.projectMileageZones = mileage_zones_obj
							vm.$store.projectUnionCollectiveAgreements = collective_agreements_obj

						}

						vm.$store.project.is_internal_project = parseInt(vm.$store.project.is_internal_project )
					}

					resolve(response)
				})
			})
		},
		fetchEstimate(jobSlug) {
			let vm = this

			let params = {
				fields: ["id","slug","collective_agreements_json"],
				include: ["JobEstimate"]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("Job/find/"+jobSlug,params).then(response => {
					if (response.success) {
						vm.$store.project.JobEstimate = response.data.JobEstimate
						vm.$store.project.collective_agreements_json = response.data.collective_agreements_json
					}

					resolve(response)
				})

			})
		},
		saveEstimate(payload) {
			let vm = this

			payload.job_id = this.$store.project.id

			if ("JobEstimate" in this.$store.project && this.$store.project.JobEstimate.length > 0 && this.$store.project.JobEstimate[0].id)
				payload.id = this.$store.project.JobEstimate[0].id

			return new Promise((resolve,reject) => {
				vm.postData("JobEstimate/save",payload,true).then(response => {
					if (response.success)
						vm.alertSaved("Estimate saved")

					resolve(response)
				})
			})
		},
		getCostsPerHour(project,classification,collectiveAgreements) {

			let costsPerHourRaw = {}

			costsPerHourRaw.reg = classification.default_cost_hr ? parseFloat(classification.default_cost_hr) : 0
			costsPerHourRaw.OT15 = classification.ot15_cost_hr ? parseFloat(classification.ot15_cost_hr) : 0
			costsPerHourRaw.OT2 = classification.ot2_cost_hr ? parseFloat(classification.ot2_cost_hr) : 0
			costsPerHourRaw.OT25 = classification.ot25_cost_hr ? parseFloat(classification.ot25_cost_hr) : 0

			let colAgr

			let collectiveAgreementsLinkObj = {}
			try {
				collectiveAgreementsLinkObj = JSON.parse(project.collective_agreements_json)

				if (collectiveAgreementsLinkObj[classification.union_id] == 0) {
					colAgr = collectiveAgreements.find(ca => ca.is_default == 1 && ca.union_id == classification.union_id)
				}
				else {
					if (classification.union_id in collectiveAgreementsLinkObj) {
						colAgr = collectiveAgreements.find(ca => ca.id == collectiveAgreementsLinkObj[classification.union_id]) 
					}
				}
			}
			catch (e) {}

			if (!colAgr)
				//fall back to default
				colAgr = collectiveAgreements.find(ca => ca.is_default == 1 && ca.union_id == classification.union_id)	

			if (colAgr) {
				let payScales = []
				try {
					payScales = JSON.parse(colAgr.pay_scales)
				}
				catch (e) {}

				//find classification in pay scales
				let classificationInPayscale = payScales.find(cl => cl.classification_id == classification.id)

				if (classificationInPayscale) {

					//There IS a payscale over-ride
					if ("default_cost_hr" in classificationInPayscale && parseFloat(classificationInPayscale.default_cost_hr) > 0) {
						//finally we have the over-ride
						costsPerHourRaw.reg = parseFloat(classificationInPayscale.default_cost_hr)
						
					}
					else if ("cost_hr" in classificationInPayscale && parseFloat(classificationInPayscale.cost_hr) > 0) {
						//finally we have the over-ride
						costsPerHourRaw.reg = parseFloat(classificationInPayscale.cost_hr)
						
					}

					if ("ot15_cost_hr" in classificationInPayscale && parseFloat(classificationInPayscale.ot15_cost_hr) > 0) {
						//finally we have the over-ride
						costsPerHourRaw.OT15 = parseFloat(classificationInPayscale.ot15_cost_hr)
						
					}

					if ("ot2_cost_hr" in classificationInPayscale && parseFloat(classificationInPayscale.ot2_cost_hr) > 0) {
						//finally we have the over-ride
						costsPerHourRaw.OT2 = parseFloat(classificationInPayscale.ot2_cost_hr)
						
					}

					if ("ot25_cost_hr" in classificationInPayscale && parseFloat(classificationInPayscale.ot25_cost_hr) > 0) {
						//finally we have the over-ride
						costsPerHourRaw.OT25 = parseFloat(classificationInPayscale.ot25_cost_hr)
						
					}
				}
			}	

			return costsPerHourRaw
		},
		clockInToProject() {
			let vm = this

			this.getLocation().then(location => {

				let distance = vm.getDistance(location.lat,location.lng,vm.$store.project.lat,vm.$store.project.long)

				if (distance < vm.$store.project.check_in_tolerance) {
					let payload = {
						service_id: 0,
						job_id: vm.$store.project.id,
						currentLat: location.lat,
						currentLong: location.lng,
						position_accuracy: location.accuracy
					}

					this.postData("TimeLog/punch-clock",payload).then(function(response){
						if (response.success) {

							if (!vm.clockInOtherUser) {
								let clockInState = "onsite"
								if ("clocked_in_offsite" in response.data && response.data.clocked_in_offsite == 1)
									clockInState = "offsite"

								vm.$bus.$emit("clockStatusChanged",clockInState)
							}

							if ("time_in" in response.data)
								vm.$store.clockinTime = response.data.time_in
							else
								vm.$store.clockinTime = null
						}
					})

				}
				else {
					//not on site, redirect to main clock in page
					vm.$router.push("/punch-clock/project/"+vm.$store.project.slug)

				}

			}).catch(error => {

				vm.showLocationError = true

			})
		}
	}
}